import type { JSX } from 'react';
import { useState } from 'react';
import { Outlet } from 'react-router';
import type { IdentifiantsEnAttente } from './connexionFlow.js';

/** Porte l'état transitoire partagé par `/connexion` et `/connexion/2fa`. */
export function ConnexionLayout(): JSX.Element {
  const [identifiantsEnAttente, poserIdentifiantsEnAttente] =
    useState<IdentifiantsEnAttente | null>(null);

  return <Outlet context={{ identifiantsEnAttente, poserIdentifiantsEnAttente }} />;
}
